import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, Router } from "@angular/router";
import { OperationsService } from "../core/services/operations.service";
import { map,  tap } from "rxjs";
import { ModalNotifyService } from "../core/services/modal-notify.service";
import { DialogService } from "../core/components/dialog/dialog.service";
import { ConfirmModalComponent } from "../core/components/dialog/components/confirm-modal/confirm-modal.component";

export const authGuardVisibilityFN = (next: ActivatedRouteSnapshot) => {
  const operations: OperationsService = inject(OperationsService);
  const dialog: DialogService = inject(DialogService);
  const idPratica: string = next.paramMap.get('idPratica');
  const idFascicolo: string = next.paramMap.get('idFascicolo');
  const openDialog = (message?: string) => dialog.open(ConfirmModalComponent, {
    data: {
      style: {width: "50%"},
      modalConfirm: {
        text: message || 'Non si dispone delle autorizzazioni necessarie a visualizzare questo fascicolo in quanto applicato un filtro sulla visibilità',
        data: [],
        hideButtons: true,
        confirmButton: true
      },
      title: 'Attenzione!',
    }
  });

  if(idPratica && !idFascicolo){
    return operations.checkPraticaExists(idPratica).pipe(
      tap(exists => {
        if (!exists) {
          openDialog('Impossibile accedere ad una pratica eliminata.');
        } else {
          operations.checkVisibilityPratica(idPratica).pipe(
            tap(el => {
              if (!el) {
                openDialog();
              }
            })
          )
        }
      })
    );
  } else if (!idPratica && idFascicolo) {
    return operations.checkFascicoloExists(idFascicolo).pipe(
      tap(exists => {
        if (!exists) {
          openDialog('Impossibile accedere a un fascicolo eliminato.');
        } else {
          operations.checkVisibilityFascicolo(null, idFascicolo).pipe(
            tap(el => {
              if (!el) {
                openDialog();
              }
            })
          )
        }
      })
    );
  }

}
